import { render, staticRenderFns } from "./edit-recruitment-form.vue?vue&type=template&id=3c2de272&scoped=true"
import script from "./edit-recruitment-form.vue?vue&type=script&lang=js"
export * from "./edit-recruitment-form.vue?vue&type=script&lang=js"
import style0 from "./edit-recruitment-form.vue?vue&type=style&index=0&id=3c2de272&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2de272",
  null
  
)

export default component.exports